import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
    ...mapState('tableInfoStore', Object.keys(state)),
    ...mapGetters('tableInfoStore',Object.keys(getters))
}

export const serviceMethods = {
    ...mapActions('tableInfoStore',Object.keys(actions)),
    ...mapMutations('tableInfoStore',Object.keys(mutations))
}
